var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconInfo = function SvgIconInfo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-303 -587) translate(304.1 587.653)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.7,
    cy: 7.7,
    r: 7.7,
    stroke: "#9EABBF",
    strokeWidth: 1.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9EABBF",
    fillRule: "nonzero",
    d: "M7.7 5.59c.619 0 1.092-.473 1.092-1.065 0-.58-.473-1.053-1.092-1.053-.632 0-1.092.474-1.092 1.053 0 .592.46 1.066 1.092 1.066zm.842 6.338V6.46H6.818v5.468h1.724z"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-info.2786136aa4cd3e307d920fc165ecc857.svg";